/**
 * ProposalEditorActions — notes textarea + error alert + Cancel/Save buttons.
 *
 * Extracted from ProposalEditor (PR 0b). Purely controlled.
 */
import React from "react";
import { Alert, Box, Button, CircularProgress, TextField } from "@mui/material";

interface Props {
  notes: string;
  setNotes: (v: string) => void;
  error: string | null;
  saving: boolean;
  onCancel?: () => void;
  handleCancel: () => void;
  handleSave: () => void;
}

const ProposalEditorActions: React.FC<Props> = ({
  notes,
  setNotes,
  error,
  saving,
  onCancel,
  handleCancel,
  handleSave,
}) => (
  <>
    <TextField
      label="Notas internas"
      multiline
      minRows={2}
      maxRows={5}
      fullWidth
      size="small"
      value={notes}
      onChange={(e) => setNotes(e.target.value)}
      sx={{ mb: 2 }}
      placeholder="Observações visíveis apenas internamente…"
    />

    {error && (
      <Alert severity="error" sx={{ mb: 1 }}>
        {error}
      </Alert>
    )}

    <Box display="flex" gap={1} justifyContent="flex-end">
      {onCancel && (
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleCancel}
          disabled={saving}
        >
          Cancelar
        </Button>
      )}
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        disabled={saving}
        startIcon={
          saving ? <CircularProgress size={16} color="inherit" /> : undefined
        }
      >
        {saving ? "A guardar…" : "Guardar rascunho"}
      </Button>
    </Box>
  </>
);

export default ProposalEditorActions;
